/**
 * This patch moves site search bindings from node.data.dyn.bind to node.data.search.bind
 */

import type {Context} from '../types';

const searchBindKeys = (bindings: Record<any, any>, keys: Array<string>) => {
  return keys.filter((key) => {
    const binding = bindings[key];
    return (
      Array.isArray(binding) &&
      binding.length > 0 &&
      binding[0] &&
      binding[0].source === 'search'
    );
  });
};

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;

  const {data = {}} = jsonNode;
  const dynBindKeys =
    data && data.dyn && data.dyn.bind && Object.keys(data.dyn.bind);
  const searchBindShallowKeys =
    dynBindKeys && searchBindKeys(data.dyn.bind, dynBindKeys);

  const searchBindDeepKeys: Record<string, string[]> | undefined =
    dynBindKeys &&
    dynBindKeys.reduce((memo: Record<string, string[]>, key: string) => {
      if (data.dyn.bind[key] && !Array.isArray(data.dyn.bind[key])) {
        // it’s a deeper binding such as style
        const deepBindKeys = Object.keys(data.dyn.bind[key]);
        const deepSearchBindKeys =
          deepBindKeys && searchBindKeys(data.dyn.bind[key], deepBindKeys);
        if (deepSearchBindKeys && deepSearchBindKeys.length > 0) {
          memo[key] = deepSearchBindKeys;
        }
      }
      return memo;
    }, {});

  const patchNeeded =
    (searchBindShallowKeys && searchBindShallowKeys.length > 0) ||
    (searchBindDeepKeys && Object.keys(searchBindDeepKeys).length > 0);

  return {
    needed: patchNeeded,
    logData: {
      msg: 'Search binding is under node.data.dyn',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (!data.search) {
        data.search = {};
      }
      if (!data.search.bind) {
        data.search.bind = {};
      }

      if (searchBindShallowKeys) {
        searchBindShallowKeys.forEach((shallowKey: any) => {
          data.search.bind[shallowKey] = data.dyn.bind[shallowKey];
          // eslint-disable-next-line webflow/no-delete
          delete data.search.bind[shallowKey][0].source;
          // eslint-disable-next-line webflow/no-delete
          delete data.dyn.bind[shallowKey];
        });
      }

      if (searchBindDeepKeys) {
        Object.keys(searchBindDeepKeys).forEach((shallowKey) => {
          const deepKeys = searchBindDeepKeys[shallowKey];
          // @ts-expect-error - TS18048 - 'deepKeys' is possibly 'undefined'.
          deepKeys.forEach((deepKey: any) => {
            if (!data.search.bind[shallowKey]) {
              data.search.bind[shallowKey] = {};
            }
            data.search.bind[shallowKey][deepKey] =
              data.dyn.bind[shallowKey][deepKey];
            // eslint-disable-next-line webflow/no-delete
            delete data.search.bind[shallowKey][deepKey][0].source;
            // eslint-disable-next-line webflow/no-delete
            delete data.dyn.bind[shallowKey][deepKey];
          });
          if (Object.keys(data.dyn.bind[shallowKey]).length === 0) {
            // eslint-disable-next-line webflow/no-delete
            delete data.dyn.bind[shallowKey];
          }
        });
        if (Object.keys(data.dyn.bind).length === 0) {
          // eslint-disable-next-line webflow/no-delete
          delete data.dyn.bind;

          if (Object.keys(data.dyn).length === 0) {
            // eslint-disable-next-line webflow/no-delete
            delete data.dyn;
          }
        }
      }
    },
  };
};
